import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GatekeeperGuard } from '@src/app/core/guards';
import { AuthGuard } from '@src/app/core/guards/auth/auth.guard';
import { ClientDataGuard } from '@src/app/core/guards/client/client-data.guard';

export const orgRoutes: Routes = [
  {
    path: 'inheritance',
    children: [
      {
        path: 'org-triage',
        data: {
          gatekeeperToggle: 'CWP_INHERITANCE_ORG_AS_BENE',
          redirectLocationWhenToggleOff: 'multi-inheritance/triage',
        },
        canActivate: [GatekeeperGuard, AuthGuard, ClientDataGuard],
        loadChildren: () =>
          import('./public/org/org-triage/org-triage.module').then((m) => m.OrgTriageModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(orgRoutes)],
  exports: [RouterModule],
})
export class OrgRoutingModule {}
